<template>
  <click-to-edit
    v-model="scope.row.weight"
    :disabled="!isFieldAvailableForEdit(scope.row, 'weight')"
    placeholder=""
    digits-only
    @input="saveElementPropChange(scope.row, 'weight')"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
export default {
  name: 'element-weight-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style>

</style>
